var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rs-label-list"},_vm._l((_vm.list),function(item,index){return _c('rs-label',{key:index,attrs:{"value":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }